import React, { useState } from 'react';
import t from '~t';
import { captureTab } from '~target';

import Cover from '~co/bookmarks/item/cover';
import { Icon } from '~ui'
import ImagePicker from '~co/picker/image';

export default function BookmarkEditFormCover({ item, onChange, onSave, onUploadCover }) {
  const [modal, setModal] = useState(false);

  const onLink = async (link) => {
    let media = [...item.media];

    if (!media.some((i) => i.link == link))
      media = [...media, { link }];

    onChange({
      cover: link,
      media,
    });

    onSave();
  };

  const handlers = {
    onClose: () => setModal(false),

    onLink,

    onScreenshot: async () => {
      const screenshot = await captureTab(item.link);

      if (typeof screenshot == 'string') await onLink('<screenshot>');
      else await handlers.onFile(screenshot);
    },

    onFile: async (file) => {
      return onUploadCover(file);
    },
  };

  return (
    <div className='ui-cover-edit-wrap'>
      <a
        href=''
        className='ui-cover-edit'
        title={t.s('changeIcon')}
        onClick={(e) => {
          e.preventDefault();
          setModal(true);
        }}
      >
        <Cover cover={item.cover} link={item.link} view='list' />

        <span className='ui-cover-edit-more'>
          <Icon name='arrow' />
        </span>
      </a>

      {modal && (
        <ImagePicker
          items={item.media}
          selected={item.cover}
          {...handlers}
        />
      )}
    </div>
  );
}
